import React, { useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import {maskPhone, validateEmail} from '../../utils/index';
import {Formik} from 'formik';
import {getConfirmationCodeForSocialLogin} from "../../actions/security";
import loadable from "../../components/Lazy";
import {
    setLoadingSpinnerOpen,
} from '../../actions/loadingSpinner';

const Recaptcha = loadable(() => import('../../components/App/Recaptcha'));

const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: '480px',
        margin: '50px auto'
    },
}));

const LoginRegistration = ({
    getConfirmationCodeForSocialLogin,
    setUserData,
    userData,
    setLoadingSpinnerOpen
}) => {
    const classes = useStyles();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = (values) => {
        setLoadingSpinnerOpen(true);
        setUserData({
            ...userData,
            name: values.firstName,
            surname: values.lastName,
            email: values.email,
            mobile: values.phone,
        });
        getConfirmationCodeForSocialLogin({
            phone: values.phone
        });
    };

    return (
        <Container>
            <div className={classes.root}>
                <Formik
                    enableReinitialize={true}
                    validateOnMount={true}
                    initialValues={{
                        firstName: userData.name || '',
                        lastName: userData.surname || '',
                        email: userData.email || '',
                        phone: userData.mobile || '',
                        recaptchaToken: ''
                    }}
                    validate={(values) => {
                        const errors = {
                            ...(!/.+$/gim.test(values.firstName) && {firstName: 'Please enter a valid first name'}),
                            ...(!/.+$/gim.test(values.lastName) && {lastName: 'Please enter a valid last name'}),
                            ...(!validateEmail(values.email) && {email: 'Please enter a valid email'}),
                            ...(!/^[0-9]{10}$/gim.test(values.phone.replace(/[^0-9]/g, '')) && {phone: 'Please enter a valid phone number'}),
                        };
                        if (Object.keys(errors).length > 0) {
                            setIsSubmitting(false);
                        }
                        return errors;
                    }}
                    onSubmit={handleSubmit}>
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        setFieldValue,
                        submitForm,
                        isValid,
                    }) => {

                        const handleRecaptchaSubmit = (recaptchaToken) => {
                            setFieldValue('recaptchaToken', recaptchaToken)
                            setIsSubmitting(true)
                            submitForm();
                        };
                        return (
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Typography variant="h2" component="h1" align="center" gutterBottom={true}>Confirm your details</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        onChange={handleChange}
                                        fullWidth={true}
                                        label="First name"
                                        variant="filled"
                                        color="primary"
                                        name="firstName"
                                        value={values.firstName}
                                        error={errors.firstName && touched.firstName && true}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        onChange={handleChange}
                                        fullWidth={true}
                                        label="Last name"
                                        variant="filled"
                                        color="primary"
                                        name="lastName"
                                        value={values.lastName}
                                        error={errors.lastName && touched.lastName && true}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        onChange={handleChange}
                                        fullWidth={true}
                                        label="Email"
                                        variant="filled"
                                        color="primary"
                                        name="email"
                                        value={values.email}
                                        error={errors.email && touched.email && true}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        onChange={(e) => {
                                            const value = e.target.value || "";
                                            setFieldValue('phone', maskPhone(value));
                                        }}
                                        fullWidth={true}
                                        label="Mobile phone number"
                                        variant="filled"
                                        color="primary"
                                        name="phone"
                                        value={values.phone}
                                        error={errors.phone && touched.phone && true}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Recaptcha
                                        onSubmit={handleRecaptchaSubmit}
                                    >
                                        {({submitAction}) => (
                                            <Button
                                                loading={isSubmitting}
                                                onClick={submitAction}
                                                disabled={!isValid || isSubmitting}
                                                fullWidth
                                                variant="contained"
                                                color="primary"
                                            >
                                                Get confirmation code
                                            </Button>
                                        )}
                                    </Recaptcha>
                                </Grid>
                            </Grid>
                        )}}
                </Formik>
            </div>
        </Container>
    )
}

export default connect(
    (state) => ({
    }),
    {
        getConfirmationCodeForSocialLogin,
        setLoadingSpinnerOpen
    }
)(LoginRegistration);